// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"83e7f3e5","596":"83e7f3e5"}[chunkId] + ".chunk.css";
};